// Zentrale Ablage für Login-Token und Benutzerdaten.
// Einziger Ort, der dafür localStorage anfasst – Komponenten, Router und Stores nutzen nur diese Funktionen.

const TOKEN_KEY = 'token';
const USER_KEY = 'user';
// Frühere Schlüssel (Login.vue/Store-Altstände); werden beim Laden und Abmelden entfernt,
// damit nach dem Logout kein gültiges Token im Browser liegen bleibt.
const LEGACY_KEYS = ['auth_token', 'auth_user', 'refreshToken'];

function read(key) {
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
}

function write(key, value) {
    try {
        if (value === null || value === undefined) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, value);
        }
    } catch {
        // Speicher nicht verfügbar (z. B. privater Modus) – Sitzung bleibt nur im Speicher
    }
}

export function getToken() {
    const token = read(TOKEN_KEY);
    return token && token.trim() !== '' ? token : null;
}

export function setToken(token) {
    write(TOKEN_KEY, token && String(token).trim() !== '' ? String(token) : null);
}

export function getUser() {
    try {
        return JSON.parse(read(USER_KEY) || 'null');
    } catch {
        return null;
    }
}

export function setUser(user) {
    write(USER_KEY, user ? JSON.stringify(user) : null);
}

function removeLegacyKeys() {
    LEGACY_KEYS.forEach((key) => write(key, null));
}

// Entfernt nur Auth-Daten; andere Einträge (z. B. Wartungsmodus-Flags) bleiben erhalten.
export function clearAuth() {
    write(TOKEN_KEY, null);
    write(USER_KEY, null);
    removeLegacyKeys();
}

removeLegacyKeys();
